module.exports = __webpack_public_path__ + "static/img/icon_wechatmini_gzh.190c5d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_wechatmini_gzh.png
// module id = mGSh
// module chunks = 1